import cn from 'clsx';
import { FC, HTMLAttributes } from 'react';

import s from './SectionDivider.module.scss';

export type SectionDividerProps = HTMLAttributes<HTMLElement>;

const SectionDivider: FC<React.PropsWithChildren<React.PropsWithChildren<SectionDividerProps>>> = ({ className, ...props }) => {
  return <hr className={cn(s.divider, className)} {...props} />;
};

export default SectionDivider;
